<template>
  <el-drawer
    title="Customer Details"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
  >
    <div v-if="isLoading" class="min-h-screen flex items-center justify-center">
      <spinner />
    </div>
    <div class="bg-muted relative flex justify-center pt-4 h-18">
      <payment-fund-icon class="-mb-9 ronded-full w-12" />
    </div>
    <section class="px-5 py-10">
      <div>
        <div class="flex flex-col items-center py-2 justify-center gap-y-2">
          <h3 class="text-2xl font-semibold mt-1">
            {{ currentPaymentLinkDetails.amount.symbol }}
            {{ addComma(currentPaymentLinkDetails.amount.amount) }}
          </h3>
          <p class="text-sm font-normal">-</p>
        </div>
        <div class="text-fg-muted">
          <ul>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>Time & Date</span>
              <span>{{
                tooltipDateContent(currentPaymentLinkDetails.createdAt)
              }}</span>
            </li>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>Transaction ID</span>
              <span
                >{{ maskID(currentPaymentLinkDetails.id) }}
                <span
                  class="cursor-pointer mb-1 ml-2"
                  v-clipboard:copy="currentPaymentLinkDetails.id"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <copy-icon />
                </span>
              </span>
            </li>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>link Name</span>
              <span class="capitalize">{{
                currentPaymentLinkDetails.title
              }}</span>
            </li>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>Link Amount</span>
              <span class="capitalize"
                >{{ currentPaymentLinkDetails.amount.symbol }}
                {{ addComma(currentPaymentLinkDetails.amount.amount) }}
              </span>
            </li>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>Fee</span>
              <span> - </span>
            </li>
            <li
              class="grid grid-cols-2 items-center text-sm font-normal border-b py-3.5 lg:py-6"
            >
              <span>Payment Method</span>
              <span class="flex items-center gap-x-2">
                <span class="capitalize">{{
                  formatServerName(currentCustomer.method)
                }}</span>
              </span>
            </li>
            <li
              class="grid grid-cols-2 items-center font-normal text-sm border-b py-3.5 lg:py-6"
            >
              <span>Currency</span>
              <span class="flex items-center gap-x-2">
                <currency-icons
                  :currency="
                    getCurrencyCountry(
                      currentPaymentLinkDetails.amount.currency
                    )
                  "
                />
                <span class="capitalize">{{
                  currentPaymentLinkDetails.amount.currency
                }}</span>
              </span>
            </li>
            <li
              class="grid grid-cols-2 items-center border-b font-normal text-sm py-3.5 lg:py-6"
            >
              <span>Exchange Rate</span>
              <span class="flex items-center gap-x-2">
                <span class="capitalize">{{
                  currentPaymentLinkDetails.exchageRate || '-'
                }}</span>
              </span>
            </li>
            <li
              class="grid grid-cols-2 items-center border-b font-normal text-sm py-3.5 lg:py-6"
            >
              <span>Amount paid</span>
              <span class="flex items-center gap-x-2">
                {{ currentPaymentLinkDetails.amount.symbol }}
                {{ addComma(currentPaymentLinkDetails.amount.amount) }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="text-fg-muted font-normal">
        <!-- customers details -->
        <p class="pt-4 pb-2 border-b">Customer Details</p>
        <div class="flex gap-x-5 p-3 items-center">
          <p>
            <profile-icon />
          </p>
          <div>
            <p class="text-xs font-thin">Customer Name</p>
            <p class="texxt-sm">
              {{
                (currentCustomer.firstName || currentCustomer.first_name) +
                  ' ' +
                  (currentCustomer.lastName || currentCustomer.last_name) || '-'
              }}
            </p>
          </div>
        </div>
        <div
          v-if="currentCustomer.phoneNumber"
          class="flex gap-x-5 p-3 items-center"
        >
          <p>
            <phone-icon />
          </p>
          <div>
            <p class="text-xs font-thin">Phone Number</p>
            <p class="text-sm">
              {{ currentCustomer.phoneNumber || '-' }}
            </p>
          </div>
        </div>
        <div class="flex gap-x-5 p-3 items-center">
          <p>
            <email-icon />
          </p>
          <div>
            <p class="text-xs font-thin">Email</p>
            <p class="text-sm">
              {{ currentCustomer.email || '-' }}
            </p>
          </div>
        </div>
        <div
          v-if="currentCustomer.address"
          class="flex gap-x-5 p-3 items-center"
        >
          <adress-icon />
          <div>
            <p class="text-xs font-thin">Address</p>
            <p class="text-sm">
              {{ currentCustomer.address || '-' }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </el-drawer>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import {
  GetCurrencyCountry,
  MaskWalletAddressTwo,
  AddComma,
  FormatServerName
} from '@/utils/helpers.js'
import app from '@/mixins/app.js'

export default {
  mixins: [app],
  name: 'CustomerDetailsDrawer',
  data () {
    return {
      breakpoints,
      isLoading: false
    }
  },
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    currentCustomer: {
      type: Object,
      required: true
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    Spinner: () => import('@/components/v2/app/Spinner.vue'),
    PaymentFundIcon: () => import('@/assets/v2/icons/PaymentFundIcon.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    ProfileIcon: () => import('@/assets/v2/icons/ProfileIcon1.vue'),
    EmailIcon: () => import('@/assets/v2/icons/EmailIcon1.vue'),
    PhoneIcon: () => import('@/assets/v2/icons/PhoneIcon1.vue'),
    AdressIcon: () => import('@/assets/v2/icons/AdressIcon.vue')
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    size () {
      return breakpoints.lgAndUp ? 50 : breakpoints.mdAndUp ? 50 : 40
    },
    currentPaymentLinkTransactions () {
      return this.$store.state.paymentLink.paymentLinkTransactions.items
    },
    currentPaymentLinkDetails () {
      return this.$store.state.paymentLink.currentPaymentLinkDetails
    }
  },
  methods: {
    addComma (val) {
      return AddComma(val.toString())
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    handleClose () {
      this.$emit('closeDrawer')
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    }
  }
}
</script>
<style scoped>
>>> .el-drawer__header > :first-child {
  font-size: 1.1rem;
  color: var(--foreground-default);
  font-weight: 600;
}
>>> .el-drawer__header {
  color: var(--foreground-default);
  background: var(--background-muted);
  font-size: 1.2rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 1.4rem;
  font-weight: 700;
  margin-bottom: 0;
}
>>> .el-drawer {
  background: var(--background-canvas) !important;
}
>>> .el-input__inner {
  background: var(--input-background);
  color: var(--input-text);
  padding-left: 2.8rem;
}
>>> .el-input__placeholder {
  color: var(--input-placeholder);
}
</style>
